import { createContext } from "react";

const SideMenuContext = createContext<any>(null);

export default SideMenuContext;
